export default __webpack_public_path__ + "1c8c58265b854e502e5af309dca2b399.png";